// extracted by mini-css-extract-plugin
export default {"container":"oF-z","disabled":"pF-z","bgBlack":"qF-z","content":"rF-z","countdown":"sF-z","topCaption":"tF-z","topHeading":"uF-z","heading":"vF-z","copy":"wF-z"};